import { render, staticRenderFns } from "./BrightSpot.vue?vue&type=template&id=bf857de6&scoped=true"
import script from "./BrightSpot.vue?vue&type=script&lang=js"
export * from "./BrightSpot.vue?vue&type=script&lang=js"
import style0 from "./BrightSpot.vue?vue&type=style&index=0&id=bf857de6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf857de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf857de6')) {
      api.createRecord('bf857de6', component.options)
    } else {
      api.reload('bf857de6', component.options)
    }
    module.hot.accept("./BrightSpot.vue?vue&type=template&id=bf857de6&scoped=true", function () {
      api.rerender('bf857de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/OutboundCallingBot/components/BrightSpot.vue"
export default component.exports